// user
export const GET_USER = "GET_USER";
export const GET_USER_SCCESS = "GET_USER_SCCESS";
export const FILL_USER_PROFILE_DATA = "FILL_USER_PROFILE_DATA";
export const PROFILE_FIRST_NAME_CHANGED = "PROFILE_FIRST_NAME_CHANGED";
export const PROFILE_LAST_NAME_CHANGED = "PROFILE_LAST_NAME_CHANGED";
export const PROFILE_PHONE_CHANGED = "PROFILE_PHONE_CHANGED";
export const PROFILE_EMAIL_CHANGED = "PROFILE_EMAIL_CHANGED";
export const PROFILE_PROVINCE_CHANGED = "PROFILE_PROVINCE_CHANGED";
export const PROFILE_GENDER_CHANGED = "PROFILE_GENDER_CHANGED";
export const PROFILE_CITY_CHANGED = "PROFILE_CITY_CHANGED";
export const PROFILE_COUNTRY_CHANGED = "PROFILE_COUNTRY_CHANGED";
export const PROFILE_PROFILE_IMAGE_CHANGED = "PROFILE_PROFILE_IMAGE_CHANGED";
export const PROFILE_COVER_IMAGE_CHANGED = "PROFILE_COVER_IMAGE_CHANGED";
export const RESET_USER_PROFILE = "RESET_USER_PROFILE";
export const POST_CONTACT_US_DATA = "POST_CONTACT_US_DATA";
export const GET_SAVED_POST_DATA = "GET_SAVED_POST_DATA";
export const GET_SAVED_POST_DATA_SUCCESS = "GET_SAVED_POST_DATA_SUCCESS";
export const GET_MY_VOTES_DATA = "GET_MY_VOTES_DATA";
export const GET_MY_VOTES_DATA_SUCCESS = "GET_MY_VOTES_DATA_SUCCESS";
export const USER_CHANGE_PASSWORD_REQUEST = "USER_CHANGE_PASSWORD_REQUEST";
export const USER_CHANGE_PASSWORD_SUCCESS = "USER_CHANGE_PASSWORD_SUCCESS";
export const UPDATE_MEDIA_VIEW_COUNT_SAVEDPOST_SUCCESS = "UPDATE_MEDIA_VIEW_COUNT_SAVEDPOST_SUCCESS";

export const USER_CHANGE_PHONE_NUMBER_REQUEST = "USER_CHANGE_PHONE_NUMBER_REQUEST";
export const USER_CHANGE_PHONE_NUMBER_SUCCESS = "USER_CHANGE_PHONE_NUMBER_SUCCESS";
export const USER_PHONE_NUMBER_VERIFY_REQUEST = "USER_PHONE_NUMBER_VERIFY_REQUEST";
export const USER_PHONE_NUMBER_VERIFY_SUCCESS = "USER_PHONE_NUMBER_VERIFY_SUCCESS";


export const RESET_SAVED_POST_DATA = "RESET_SAVED_POST_DATA";
export const EVALUATION = "EVALUATION";
export const EVALUATION_DATA = "EVALUATION_DATA";
export const RESET_EVALUATION_DATA = "RESET_EVALUATION_DATA";

// app level loader
export const SHOW_APP_LOADER = "SHOW_APP_LOADER";
export const HIDE_APP_LOADER = "HIDE_APP_LOADER";

// home
export const GET_HOME_DATA = "GET_HOME_DATA";
export const GET_HOME_DATA_SUCCESS = "GET_HOME_DATA_SUCCESS";
export const GET_CONTEST_HOME_PAGE_DATA = "GET_CONTEST_HOME_PAGE_DATA";
export const GET_CONTEST_HOME_PAGE_DATA_SUCCESS = "GET_CONTEST_HOME_PAGE_DATA_SUCCESS";
export const GET_FEATURE_VIDEO = "GET_FEATURE_VIDEO";
export const GET_FEATURE_VIDEO_SUCCESS = "GET_FEATURE_VIDEO_SUCCESS";
export const GET_CONTEST_DATA = "GET_CONTEST_DATA";
export const GET_CONTEST_DATA_SUCCESS = "GET_CONTEST_DATA_SUCCESS";
export const GET_COUNTRY_WISE_CONTEST_DATA = "GET_COUNTRY_WISE_CONTEST_DATA";
export const GET_COUNTRY_WISE_CONTEST_DATA_SUCCESS = "GET_COUNTRY_WISE_CONTEST_DATA_SUCCESS";
export const HOME_DATA_LOADED = "HOME_DATA_LOADED";
export const GET_MY_ACTIVITY = "GET_MY_ACTIVITY";
export const GET_MY_ACTIVITY_SUCCESS = "GET_MY_ACTIVITY_SUCCESS";
export const GET_MONTHLY_ACTIVE_VOTERS = "GET_MONTHLY_ACTIVE_VOTERS";
export const GET_MONTHLY_ACTIVE_VOTERS_SUCCESS = "GET_MONTHLY_ACTIVE_VOTERS_SUCCESS";
export const SET_MY_ACTIVITY_LOADER = "SET_MY_ACTIVITY_LOADER";
export const UPDATE_MEDIA_VIEW_COUNT_FEATURED_VIDEOS_SUCCESS = "UPDATE_MEDIA_VIEW_COUNT_FEATURED_VIDEOS_SUCCESS";
export const HOME_ERROR = "HOME_ERROR";

//Contests

export const GET_CONTEST_DETAIL = "GET_CONTEST_DETAIL";
export const GET_CONTEST_DETAIL_SUCCESS = "GET_CONTEST_DETAIL_SUCCESS";
export const GET_CONTEST_DETAIL_TALENTS = "GET_CONTEST_DETAIL_TALENTS";
export const GET_CONTEST_DETAIL_TALENTS_SUCCESS = "GET_CONTEST_DETAIL_TALENTS_SUCCESS";
export const GET_CONTEST_DETAIL_MONTHLY_WINNERS = "GET_CONTEST_DETAIL_MONTHLY_WINNERS";
export const GET_CONTEST_DETAIL_MONTHLY_WINNERS_SUCCESS = "GET_CONTEST_DETAIL_MONTHLY_WINNERS_SUCCESS";
export const GET_JUDGES_COMMITTEE = "GET_JUDGES_COMMITTEE";
export const GET_JUDGES_COMMITTEE_SUCCESS = "GET_JUDGES_COMMITTEE_SUCCESS";
export const GET_CONTESTEE_FEED = "GET_CONTESTEE_FEED";
export const GET_CONTESTEE_FEED_SUCCESS = "GET_CONTESTEE_FEED_SUCCESS";
export const GET_VOTERS_ACTIVITY = "GET_VOTERS_ACTIVITY";
export const GET_VOTERS_ACTIVITY_SUCCESS = "GET_VOTERS_ACTIVITY_SUCCESS";
export const RESET_CONTEST_DETAIL = "RESET_CONTEST_DETAIL";
export const CONTEST_ERROR = "CONTEST_ERROR";
export const CONTEST_DETAIL_ERROR = "CONTEST_DETAIL_ERROR";

//Auth

export const PHONE_NUMBER_CHANGED = "PHONE_NUMBER_CHANGED";
export const PASSWORD_CHANGED = "PASSWORD_CHANGED";
export const CONFIRM_PASSWORD_CHANGED = "CONFIRM_PASSWORD_CHANGED";
export const REFERRAL_CODE_CHANGED = "REFERRAL_CODE_CHANGED";
export const COUNTRY_CODE_CHANGED = "COUNTRY_CODE_CHANGED";
export const COUNTRY_LIST = "COUNTRY_LIST";
export const COUNTRY_LIST_SUCCESS = "COUNTRY_LIST_SUCCESS";
export const SEARCH_COUNTRY_LIST = "SEARCH_COUNTRY_LIST";
export const PROVINCE_LIST = "PROVINCE_LIST";
export const PROVINCE_LIST_SUCCESS = "PROVINCE_LIST_SUCCESS";
export const CITY_LIST = "CITY_LIST";
export const CITY_LIST_SUCCESS = "CITY_LIST_SUCCESS";
export const SIGNUP_REQUEST = "SIGNUP_REQUEST";
export const SIGNUP_REQUEST_SUCCESS = "SIGNUP_REQUEST_SUCCESS"
export const SIGNIN_REQUEST = "SIGNIN_REQUEST";
export const SIGNIN_REQUEST_SUCCESS = "SIGNIN_REQUEST_SUCCESS";
export const FORGOT_PASSWORD_REQUEST = "FORGOT_PASSWORD_REQUEST";
export const FORGOT_PASSWORD_REQUEST_SUCCESS = "FORGOT_PASSWORD_REQUEST_SUCCESS";
export const PHONE_VERIFICATION_CHANGE = "PHONE_VERIFICATION_CHANGE";
export const PHONE_VERIFICATION_REQUEST = "PHONE_VERIFICATION_REQUEST";
export const PHONE_VERIFICATION_REQUEST_SUCCESS = "PHONE_VERIFICATION_REQUEST_SUCCESS";
export const PHONE_VERIFICATION_RESEND_REQUEST = "PHONE_VERIFICATION_RESEND_REQUEST";
export const PHONE_VERIFICATION_RESEND_REQUEST_SUCCESS = "PHONE_VERIFICATION_RESEND_REQUEST_SUCCESS";
export const LOGOUT_REQUEST = "LOGOUT_REQUEST";
export const LOGOUT_REQUEST_SUCCESS = "LOGOUT_REQUEST_SUCCESS";
export const LOGOUT_REQUEST_FAIL = "LOGOUT_REQUEST_FAIL";
export const SIGNUP_PROFILE = "SIGNUP_PROFILE";
export const SIGNUP_PROFILE_SUCCESS = "SIGNUP_PROFILE_SUCCESS";
export const CHANGE_REDIRECT_URL = "CHANGE_REDIRECT_URL";
export const TERMS_CONDITIONS_CHANGE = "TERMS_CONDITIONS_CHANGE";
export const CHANGE_PASSWORD = "CHANGE_PASSWORD";
export const CHANGE_PASSWORD_SUCCESS = "CHANGE_PASSWORD_SUCCESS";
export const RESET_PHONE_AND_PASSWORD = "RESET_PHONE_AND_PASSWORD";

//Enroll Contest

export const ENROLL_CONTEST_FIRST_NAME_CHANGED = "ENROLL_CONTEST_FIRST_NAME_CHANGED";
export const ENROLL_CONTEST_LAST_NAME_CHANGED = "ENROLL_CONTEST_LAST_NAME_CHANGED";
export const ENROLL_CONTEST_PHONE_CHANGED = "ENROLL_CONTEST_PHONE_CHANGED";
export const ENROLL_CONTEST_COUNTRY_CODE_CHANGED = "ENROLL_CONTEST_COUNTRY_CODE_CHANGED";
export const ENROLL_CONTEST_EMAIL_CHANGED = "ENROLL_CONTEST_EMAIL_CHANGED";
export const ENROLL_CONTEST_GENDER_CHANGED = "ENROLL_CONTEST_GENDER_CHANGED";
export const ENROLL_CONTEST_COUNTRY_CHANGED = "ENROLL_CONTEST_COUNTRY_CHANGED";
export const ENROLL_CONTEST_PROVINCE_CHANGED = "ENROLL_CONTEST_PROVINCE_CHANGED";
export const ENROLL_CONTEST_CITY_CHANGED = "ENROLL_CONTEST_CITY_CHANGED";
export const ENROLL_CONTEST_CONTEST_CHANGED = "ENROLL_CONTEST_CONTEST_CHANGED";
export const ENROLL_CONTEST_ABOUT_YOURSELF_CHANGED = "ENROLL_CONTEST_ABOUT_YOURSELF_CHANGED";
export const ENROLL_CONTEST_TILL_WHEN_CHANGED = "ENROLL_CONTEST_TILL_WHEN_CHANGED";
export const ENROLL_CONTEST_PROFILE_IMAGE_CHANGED = "ENROLL_CONTEST_PROFILE_IMAGE_CHANGED";
export const ENROLL_CONTEST_REQUEST = "ENROLL_CONTEST_REQUEST";
export const ENROLL_CONTEST_REQUEST_SUCCESS = "ENROLL_CONTEST_REQUEST_SUCCESS";
export const ENROLL_CONTEST_GET_ENROLLED_CONTESTS = "ENROLL_CONTEST_ENROLLED_CONTESTS";
export const ENROLL_CONTEST_GET_ENROLLED_CONTESTS_SUCCESS = "ENROLL_CONTEST_ENROLLED_CONTESTS_SUCCESS";
export const ENROLL_CONTEST_REMOVE_ENROLLED_CONTESTS = "ENROLL_CONTEST_REMOVE_ENROLLED_CONTESTS";
export const ENROLL_CONTEST_FILL_USER_DATA = "ENROLL_CONTEST_FILL_USER_DATA";
export const ENROLL_CONTEST_NOT_FOR_ME = "ENROLL_CONTEST_NOT_FOR_ME";
export const GET_CONTEST_LIST = "GET_CONTEST_LIST";
export const GET_CONTEST_LIST_SUCCESS = "GET_CONTEST_LIST_SUCCESS";
export const GIVE_VOTE = "GIVE_VOTE";
export const GIVE_VOTE_SUCCESS = "GIVE_VOTE_SUCCESS";
export const GIVE_VOTE_SUCCESS_EXPLORE = "GIVE_VOTE_SUCCESS_EXPLORE";
export const GIVE_VOTE_SUCCESS_FEATURE_VIDEO = "GIVE_VOTE_SUCCESS_FEATURE_VIDEO";
export const GIVE_VOTE_SUCCESS_CONTEST_DETAILS = "GIVE_VOTE_SUCCESS_CONTEST_DETAILS";





//explore screen
export const GET_EXPLORE_DATA = "GET_EXPLORE_DATA";
export const GET_EXPLORE_DATA_SUCCESS = "GET_EXPLORE_DATA_SUCCESS";
export const UPDATE_MEDIA_VIEW_COUNT_EXPLORE_SUCCESS = "UPDATE_MEDIA_VIEW_COUNT_EXPLORE_SUCCESS";
export const RESET_EXPLORE_DATA = "RESET_EXPLORE_DATA";

//single media screen
export const GET_SINGLE_MEDIA_DATA = "GET_SINGLE_MEDIA_DATA";
export const GET_SINGLE_MEDIA_DATA_SUCCESS = "GET_SINGLE_MEDIA_DATA_SUCCESS";
export const RESET_SINGLE_MEDIA_DATA = "RESET_SINGLE_MEDIA_DATA";
export const SEND_MEDIA_LIKE_FEEDBACK_SUCCESS = "SEND_MEDIA_LIKE_FEEDBACK_SUCCESS";
export const GIVE_VOTE_SUCCESS_SINGLE_MEDIA = "GIVE_VOTE_SUCCESS_SINGLE_MEDIA";
export const UPDATE_SINGLE_MEDIA_VIEW_COUNT_SUCCESS = "UPDATE_SINGLE_MEDIA_VIEW_COUNT_SUCCESS";

//user feedback
export const POST_USER_FEEDBACK = "POST_USER_FEEDBACK";

// modal
export const MODAL_OPEN = "MODAL_OPEN";
export const MODAL_CLOSE = "MODAL_CLOSE";

// conformationModal
export const CONFORMATION_MODAL_OPEN = "CONFORMATION_MODAL_OPEN";
export const CONFORMATION_MODAL_CLOSE = "CONFORMATION_MODAL_CLOSE";
export const GET_REPORT_MODAL_REASON_DATA = "GET_REPORT_MODAL_REASON_DATA";
export const GET_REPORT_MODAL_REASON_DATA_SUCCESS = "GET_REPORT_MODAL_REASON_DATA_SUCCESS";
export const POST_REPORT = "POST_REPORT";
export const POST_REPORT_SUCCESS = "POST_REPORT_SUCCESS";




// votingTicketModal
export const VOTING_TICKET_MODAL_OPEN = "VOTING_TICKET_MODAL_OPEN";
export const VOTING_TICKET_MODAL_CLOSE = "VOTING_TICKET_MODAL_CLOSE";

// socialShareModal
export const SOCIAL_SHARE_MODAL_OPEN = "SOCIAL_SHARE_MODAL_OPEN";
export const SOCIAL_SHARE_MODAL_CLOSE = "SOCIAL_SHARE_MODAL_CLOSE";
export const SOCIAL_SHARE_COUNT = "SOCIAL_SHARE_COUNT";

// socialShareModal
export const IMAGE_CROP_SOCIAL_SHARE_MODAL_OPEN = "IMAGE_CROP_SOCIAL_SHARE_MODAL_OPEN";
export const IMAGE_CROP_SOCIAL_SHARE_MODAL_CLOSE = "IMAGE_CROP_SOCIAL_SHARE_MODAL_CLOSE";

// voterInfoModal
export const VOTER_INFO_MODAL_OPEN = "VOTER_INFO_MODAL_OPEN";
export const VOTER_INFO_MODAL_CLOSE = "VOTER_INFO_MODAL_CLOSE";

// reportModal
export const REPORT_MODAL_OPEN = "REPORT_MODAL_OPEN";
export const REPORT_MODAL_CLOSE = "REPORT_MODAL_CLOSE";

// profileMediaModal
export const PROFILE_MEDIA_MODAL_OPEN = "PROFILE_MEDIA_MODAL_OPEN";
export const PROFILE_MEDIA_MODAL_CLOSE = "PROFILE_MEDIA_MODAL_CLOSE";

// contest profile
export const GET_USER_CONTEST_PROFILE_DATA = "GET_USER_CONTEST_PROFILE_DATA";
export const GET_USER_CONTEST_PROFILE_DATA_SUCCESS = "GET_USER_CONTEST_PROFILE_DATA_SUCCESS";
export const GET_USER_CONTEST_PROFILE_MEDIA = "GET_USER_CONTEST_PROFILE_MEDIA";
export const GET_USER_CONTEST_PROFILE_MEDIA_SUCCESS = "GET_USER_CONTEST_PROFILE_MEDIA_SUCCESS";
export const SHOW_UPLOAD_MEDIA_LOADER = "SHOW_UPLOAD_MEDIA_LOADER";
export const HIDE_UPLOAD_MEDIA_LOADER = "HIDE_UPLOAD_MEDIA_LOADER";
export const SHOW_CONTEST_PROFILE_VIEW_PROFILE_PIC = "SHOW_CONTEST_PROFILE_VIEW_PROFILE_PIC";
export const HIDE_CONTEST_PROFILE_VIEW_PROFILE_PIC = "HIDE_CONTEST_PROFILE_VIEW_PROFILE_PIC";
export const SHOW_CONTEST_PROFILE_VIEW_INTRO_VIDEO = "SHOW_CONTEST_PROFILE_VIEW_INTRO_VIDEO";
export const HIDE_CONTEST_PROFILE_VIEW_INTRO_VIDEO = "HIDE_CONTEST_PROFILE_VIEW_INTRO_VIDEO";
export const UPDATE_PROFILE_MEDIA = "UPDATE_PROFILE_MEDIA";
export const UPDATE_PROFILE_MEDIA_SUCCESS = "UPDATE_PROFILE_MEDIA_SUCCESS";
export const RESET_CONTEST_PROFILE = "RESET_CONTEST_PROFILE";
export const SEND_CONTEST_LIKE_FEEDBACK = "SEND_CONTEST_LIKE_FEEDBACK";
export const SEND_CONTEST_LIKE_FEEDBACK_SUCCESS = "SEND_CONTEST_LIKE_FEEDBACK_SUCCESS";
export const SEND_CONTEST_LIKE_FEATURED_VIDEO_FEEDBACK_SUCCESS = "SEND_CONTEST_LIKE_FEATURED_VIDEO_FEEDBACK_SUCCESS";
export const SEND_CONTEST_LIKE_CONTEST_DETAIL_FEEDBACK_SUCCESS = "SEND_CONTEST_LIKE_CONTEST_DETAIL_FEEDBACK_SUCCESS";
export const UPDATE_MEDIA_VIEW_COUNT_CONTESTPROFILE_SUCCESS = "UPDATE_MEDIA_VIEW_COUNT_CONTESTPROFILE_SUCCESS";

export const SEND_CONTEST_MEDIA_REPORT = "SEND_CONTEST_MEDIA_REPORT";
export const SEND_CONTEST_MEDIA_REPORT_SUCCESS = "SEND_CONTEST_MEDIA_REPORT_SUCCESS";
export const SEND_CONTEST_MEDIA_DELETE = "SEND_CONTEST_MEDIA_DELETE";
export const SEND_CONTEST_MEDIA_DELETE_SUCCESS = "SEND_CONTEST_MEDIA_DELETE_SUCCESS";


export const SHARE_CONTEST_DATA = "SHARE_CONTEST_DATA";
export const SHARE_CONTEST_DATA_SUCCESS = "SHARE_CONTEST_DATA_SUCCESS";
export const SET_CONTEST_BOOKMARK = "SET_CONTEST_BOOKMARK";
export const SET_CONTEST_BOOKMARK_SUCCESS = "SET_CONTEST_BOOKMARK_SUCCESS";
export const REMOVE_CONTEST_LIKE_FEEDBACK = "REMOVE_CONTEST_LIKE_FEEDBACK";
export const REMOVE_CONTEST_LIKE_SUCCESS = "REMOVE_CONTEST_LIKE_FEEDBACK_SUCCESS";

// new post

export const CONTEST_POST = "CONTEST_POST";
export const CONTEST_POST_SUCCESS = "CONTEST_POST_SUCCESS";

// comman
export const FILTER_LIST_DATA = "FILTER_LIST_DATA";
export const GET_FILTER_LIST_DATA = "GET_FILTER_LIST_DATA";
export const GET_FILTER_LIST_DATA_SUCCESS = "GET_FILTER_LIST_DATA_SUCCESS";
export const RESET_FILTER_LIST_DATA = "RESET_FILTER_LIST_DATA";
export const UPDATE_MEDIA_VIEW_COUNT = "UPDATE_MEDIA_VIEW_COUNT";
export const UPDATE_MEDIA_VIEW_COUNT_SUCCESS = "UPDATE_MEDIA_VIEW_COUNT_SUCCESS";

// apply to be host
export const APPLY_FOR_HOST = "APPLY_FOR_HOST";
export const GET_HOST_PROFILE_MEDIA = "GET_HOST_PROFILE_MEDIA";
export const GET_HOST_PROFILE_MEDIA_SUCCESS = "GET_HOST_PROFILE_MEDIA_SUCCESS";
export const GET_HOST_PROFILE_DATA = "GET_HOST_PROFILE_DATA";
export const GET_HOST_PROFILE_DATA_SUCCESS = "GET_HOST_PROFILE_DATA_SUCCESS";
export const GET_ENROLLED_HOST_DATA = "GET_ENROLLED_HOST_DATA";
export const GET_ENROLLED_HOST_DATA_SUCCESS = "GET_ENROLLED_HOST_DATA_SUCCESS";
export const UPLOAD_HOST_CONTEST_DATA = "UPLOAD_HOST_CONTEST_DATA";
export const SEE_MORE_DATA = "SEE_MORE_DATA";
export const SEE_MORE_DATA_SUCCESS = "SEE_MORE_DATA_SUCCESS";
export const RESET_HOST_PROFILE_DATA = "RESET_HOST_PROFILE_DATA";

// search
export const SEARCH_TEXT = "SEARCH_TEXT";
export const SEARCH_TYPE = "SEARCH_TYPE";
export const GET_SEARCH_DATA = "GET_SEARCH_DATA";
export const GET_SEARCH_CONTESTANTS_DATA_SUCCESS = "GET_SEARCH_CONTESTANTS_DATA_SUCCESS";
export const GET_SEARCH_CONTEST_DATA_SUCCESS = "GET_SEARCH_CONTEST_DATA_SUCCESS";
export const GET_SEARCH_VOTER_DATA_SUCCESS = "GET_SEARCH_VOTER_DATA_SUCCESS";


//NOtification

export const GET_NOTIFICATION_LIST = "GET_NOTIFICATION_LIST";
export const GET_NOTIFICATION_LIST_SUCCESS = "GET_NOTIFICATION_LIST_SUCCESS";
export const NOTIFICATION_SWITCH = "NOTIFICATION_SWITCH";
export const NOTIFICATION_SWITCH_CHANGE = "NOTIFICATION_SWITCH_CHANGE";
export const NOTIFICATION_MARK_AS_READ = "NOTIFICATION_MARK_AS_READ";
export const NOTIFICATION_MARK_AS_READ_SUCCESS = "NOTIFICATION_MARK_AS_READ_SUCCESS";
